module.exports = __webpack_public_path__ + "img/icn-hot.aa4b150b.png";